(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["card-quick-buy"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('lvl-quick-buy')) return;

    var MOBILE = window.matchMedia('(max-width: 749px)');
    var openInstance = null;

    class LvlQuickBuy extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-qb-trigger]');
        this.direct = this.querySelector('[data-qb-direct]');
        this.panel = this.querySelector('[data-qb-panel]');
        this.live = this.querySelector('[data-qb-live]');
        this.content = this.closest('.product-card__content');

        // Clicks inside the footer must never reach the card link / card click handler
        this.addEventListener('click', function (e) { e.stopPropagation(); });

        if (this.trigger) this.trigger.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
        if (this.direct) this.direct.addEventListener('click', () => this.add(null, this.direct));

        if (this.panel) {
          this.form = this.panel.querySelector('[data-qb-form]');
          this.submit = this.panel.querySelector('[data-qb-submit]');
          this.submitPrice = this.panel.querySelector('[data-qb-submit-price]');
          this.error = this.panel.querySelector('[data-qb-error]');
          this.plan = this.panel.querySelector('[data-qb-plan]');

          this.panel.addEventListener('click', function (e) { e.stopPropagation(); });
          this.panel.querySelector('[data-qb-close]').addEventListener('click', () => this.close());
          this.form.addEventListener('change', () => this.syncPrice());
          this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            var sub = this.form.querySelector('input[name="purchase"]:checked').value === 'subscription';
            this.add(sub ? this.plan.value : null, this.submit);
          });
          this.panel.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.stopPropagation(); this.close(); } });
        }

        this.measure();
        if (window.ResizeObserver && this.content) {
          this.ro = new ResizeObserver(() => this.measure());
          this.ro.observe(this.content);
          this.ro.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.isOpen) this.close(true);
      }

      // Hover overlay stops at the top edge of this footer
      measure() {
        if (!this.content) return;
        var c = this.content.getBoundingClientRect();
        var f = this.getBoundingClientRect();
        var h = Math.max(0, Math.round(c.bottom - f.top));
        this.content.style.setProperty('--lvl-qb-h', h + 'px');
      }

      selectedPrice() {
        var sub = this.form.querySelector('input[name="purchase"]:checked').value === 'subscription';
        if (!sub) return this.dataset.onetimePrice;
        return this.plan.dataset.price;
      }

      syncPrice() {
        this.submitPrice.textContent = this.selectedPrice();
      }

      open() {
        if (openInstance && openInstance !== this) openInstance.close(true);
        openInstance = this;
        this.isOpen = true;
        this.error.hidden = true;

        if (MOBILE.matches) {
          this.backdrop = document.createElement('div');
          this.backdrop.className = 'lvl-qb-backdrop';
          this.backdrop.addEventListener('click', () => this.close());
          document.body.appendChild(this.backdrop);
          this.panel.classList.add('is-sheet');
          this.panel.setAttribute('aria-modal', 'true');
          document.body.appendChild(this.panel);
          // Pin the sheet to the VISIBLE screen: if anything on the page overflows
          // sideways, position:fixed alone would size it to the wider layout viewport.
          this.fitSheet = () => {
            var vv = window.visualViewport;
            if (!vv) return;
            this.panel.style.left = vv.offsetLeft + 'px';
            this.panel.style.width = vv.width + 'px';
            this.panel.style.right = 'auto';
            this.panel.style.bottom = Math.max(0, window.innerHeight - (vv.offsetTop + vv.height)) + 'px';
          };
          this.fitSheet();
          if (window.visualViewport) {
            visualViewport.addEventListener('resize', this.fitSheet);
            visualViewport.addEventListener('scroll', this.fitSheet);
          }
        }

        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
          this.panel.classList.add('is-open');
          if (this.backdrop) this.backdrop.classList.add('is-open');
        });
        var checked = this.panel.querySelector('input[name="purchase"]:checked');
        if (checked) checked.focus({ preventScroll: true });

        this.onDocClick = (e) => { if (!this.panel.contains(e.target) && !this.contains(e.target)) this.close(); };
        this.onDocKey = (e) => { if (e.key === 'Escape') this.close(); };
        setTimeout(() => {
          document.addEventListener('click', this.onDocClick);
          document.addEventListener('keydown', this.onDocKey);
        });
      }

      close(silent) {
        if (!this.isOpen) return;
        this.isOpen = false;
        if (openInstance === this) openInstance = null;
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onDocKey);
        if (this.fitSheet && window.visualViewport) {
          visualViewport.removeEventListener('resize', this.fitSheet);
          visualViewport.removeEventListener('scroll', this.fitSheet);
          this.fitSheet = null;
        }

        this.panel.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        var panel = this.panel;
        var backdrop = this.backdrop;
        this.backdrop = null;
        if (backdrop) backdrop.classList.remove('is-open');
        setTimeout(() => {
          panel.hidden = true;
          if (panel.classList.contains('is-sheet')) {
            panel.classList.remove('is-sheet');
            panel.removeAttribute('aria-modal');
            panel.style.left = panel.style.width = panel.style.right = panel.style.bottom = '';
            this.appendChild(panel);
          }
          if (backdrop) backdrop.remove();
        }, 280);
        if (!silent) this.trigger.focus({ preventScroll: true });
      }

      async add(sellingPlan, button) {
        if (this.busy) return;
        this.busy = true;
        button.disabled = true;
        if (this.error) this.error.hidden = true;

        var item = { id: Number(this.dataset.variantId), quantity: 1 };
        if (sellingPlan) item.selling_plan = Number(sellingPlan);
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

        try {
          var res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] }),
          });
          if (!res.ok) throw new Error('add failed');

          if (this.isOpen) this.close(true);
          this.flashAdded();
          this.live.textContent = 'Added ' + this.dataset.productName + (sellingPlan ? ' (subscription)' : '') + ' to cart';
          setTimeout(() => { this.live.textContent = ''; }, 2800);
          this.notifyTheme();
        } catch (err) {
          if (this.error && this.isOpen) {
            this.error.hidden = false;
          } else {
            this.live.textContent = "Couldn't add to cart. Try again.";
          }
        } finally {
          this.busy = false;
          button.disabled = false;
        }
      }

      flashAdded() {
        var btn = this.trigger || this.direct;
        var label = btn.querySelector('.lvl-qb__trigger-label');
        var original = label.textContent;
        btn.classList.add('is-added');
        label.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Added to cart';
        clearTimeout(this.flashTimer);
        this.flashTimer = setTimeout(() => {
          btn.classList.remove('is-added');
          label.textContent = original;
        }, 1600);
      }

      // Update Horizon's header cart count directly. We deliberately do NOT fire the
      // theme's 'cart:update' event: Horizon's own drawer auto-opens on it, and Bonde
      // already opens its drawer by itself when it sees the /cart/add.js request.
      async notifyTheme() {
        try {
          var cart = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js').then((r) => r.json());
          document.querySelectorAll('cart-icon').forEach(function (icon) {
            if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count, false);
          });
        } catch (e) {}
      }
    }

    customElements.define('lvl-quick-buy', LvlQuickBuy);
  })();
  } catch(e) { console.error(e); }
})();

})();
